import AppConfigService from "@/services/AppConfig.js"

const picaIconLogo = require("@/assets/pica-icon.svg")

const state = {
    appConfigReady: false, // used to control UI
    eventOwnerId: 34, // GetPica on production
    appLogo: picaIconLogo,
    hideCart: false,
    privacyCheckboxes: [],
    footerCompanyInfo: null,
    footerCategories: [],
    hideAppStoreLinks: false,
    hidePoweredByLogo: false,
    hideMarketingConsentLastupdateDate: false,
    loginSubtitle: null,
    marketingConsentDescription: null,
    showCalendar: false,
    disableSocialLogin: false,
    faceCheckinPrivacyStatement: null,
    language: localStorage.getItem('user_language') || (navigator.language.includes('-') ? navigator.language.split('-')[0] : navigator.language) || 'en',
    appEnv: localStorage.getItem('app_env') || '',
    minRequiredAge: null,
    minRequiredAgePolicyUrl: null,
    disallowAddPicaCode: process.env.VUE_APP_DISALLOW_ADD_PICACODE === '1',
    disallowAlbumDeletion: process.env.VUE_APP_DISALLOW_ALBUM_DELETION === '1',
    canChangePassword: process.env.VUE_APP_AUTH_PROVIDERS.split(',').includes('password')
}

const mutations = {
    SET_CONFIG(state, config) {
        state.appConfigReady = true
        state.eventOwnerId = config.id
        state.appLogo = config.logo
        state.hideCart = config.hide_cart
        state.footerCompanyInfo = config.footer_company_info
        state.footerCategories = config.footer_categories
        state.privacyCheckboxes = config.privacy_checkboxes
        state.appIcons = config.icons
        state.hideAppStoreLinks = config.hide_app_store_links
        state.hidePoweredByLogo = config.hide_powered_by_logo
        state.hideMarketingConsentLastupdateDate = config.hide_marketing_consent_last_update_date
        state.loginSubtitle = config.login_subtitle
        state.marketingConsentDescription = config.marketing_consent_description
        state.showCalendar = config.show_calendar
        state.disableSocialLogin = config.disable_social_login
        state.faceCheckinPrivacyStatement = config.face_checkin_privacy_statement,
        state.minRequiredAge = config.min_required_age
        state.minRequiredAgePolicyUrl = config.min_required_age_policy_url
    },
    SET_APP_CONFIG_READY(state, ready= true) {
        state.appConfigReady = ready
    },
    SET_APP_ENV(state, appEnv) {
        state.appEnv = appEnv
    },
    SET_LANGUAGE(state, lang) {
        state.language = lang
        localStorage.setItem('user_language', lang)
    }
}

const getters = {
    appConfigReady: (state) => state.appConfigReady,
    getEventOwnerId: (state) => state.eventOwnerId,
    getAppLogo: (state) => state.appLogo || picaIconLogo,
    getFooterCategories: (state) => state.footerCategories,
    getFooterCompanyInfo: (state) => state.footerCompanyInfo,
    getPrivacyCheckboxes: (state) => state.privacyCheckboxes,
    getHideAppStoreLinks: (state) => state.hideAppStoreLinks,
    getHidePoweredByLogo: (state) => state.hidePoweredByLogo,
    getAppConfigReady: (state) => state.appConfigReady,
    hideCart: (state) => state.hideCart,
    isRunningInWebview: (state) => state.appEnv === 'webview',
    disableSocialLogin: (state) => state.disableSocialLogin,
    minRequiredAge: (state) => state.minRequiredAge,
    minRequiredAgePolicyUrl: (state) => state.minRequiredAgePolicyUrl,
    loginSubtitle: (state) => state.loginSubtitle,
    disallowAddPicaCode: (state) => state.disallowAddPicaCode,
    disallowAlbumDeletion: (state) => state.disallowAlbumDeletion,
    canChangePassword: (state) => state.canChangePassword
}

const actions = {
    getConfig(context, params) {
        return AppConfigService.getConfiguration(params.appName)
            .then(response => {
                context.commit('SET_CONFIG', response.data)
                return response
            })
            .catch(function (error) {
                // EVENT OWNER DOES NOT EXIST => WILL BE USED PICA DEFAULT CONFIGURATION
                if (error.response.status === 404) {
                    context.commit("SET_APP_CONFIG_READY")
                }
                return error
            })
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
